import type { IJobApplicationStore } from '../../../../../stores/JobApplicationStore';
import { parseEmailSubjectLength } from './../../../../../utils/parseEmailSubjectLength';
import SendProspectEmailForm from '../../../../details/ProspectEmail/SendProspectEmailForm/SendProspectEmailForm';
import type { BulkActionItemChildProps } from '../BulkActionItem';
import translations from '../.vocab';
import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

interface Props {
  jobApplicationStore: IJobApplicationStore;
  closeAndShowSuccessMessage: BulkActionItemChildProps['closeAndShowSuccessMessage'];
  onCancel: BulkActionItemChildProps['onCancel'];
  selectedJobApplicationsCount: BulkActionItemChildProps['selectedJobApplicationsCount'];
}

const SendBulkProspectEmail = ({
  jobApplicationStore,
  closeAndShowSuccessMessage,
  onCancel,
  selectedJobApplicationsCount,
}: Props) => {
  const { t } = useTranslations(translations);
  const { language } = useAppConfig();
  const emailSubject = t(
    'advertiserName has responded to your application for jobTitle',
    {
      advertiserName:
        jobApplicationStore.rootStore.userStore.user.advertiserName,
      jobTitle: jobApplicationStore.jobStore.job.jobInformation.title,
    },
  );

  const defaultMessageText = t('Hi [firstname],');

  const onSendProspectEmail = async (
    subject: string,
    message: string,
    enableReplies: boolean,
  ) =>
    await jobApplicationStore.sendProspectEmail({
      subject,
      message,
      enableReplies,
      language,
    });

  return (
    <SendProspectEmailForm
      onSendProspectEmail={onSendProspectEmail}
      onSubmitSuccess={closeAndShowSuccessMessage}
      onCancel={onCancel}
      fromName={jobApplicationStore.rootStore.userStore.user.name}
      fromEmail={jobApplicationStore.rootStore.userStore.user.email}
      messageDefaultText={defaultMessageText}
      subjectDefaultText={parseEmailSubjectLength(emailSubject)}
      selectedJobApplicationsCount={selectedJobApplicationsCount}
      subHeading={
        <Text>{t('Each candidate listed will receive separate emails.')}</Text>
      }
    />
  );
};

export default SendBulkProspectEmail;
